// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__245ZJ","left":"styles_left__1EEDH","desktopActions":"styles_desktopActions__vWANT","title":"styles_title__3eYNW"};